import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
type Faq = {
  question: string;
  answer: string[];
  bullets?: string[];
};
const faqs: Faq[] = [{
  question: 'Comment vais-je recevoir le produit ?',
  answer: ['Après votre achat, vous recevrez un accès numérique au matériel afin de pouvoir commencer à le consulter immédiatement.']
}, {
  question: 'Sous quel format vais-je recevoir le contenu ?',
  answer: ['Tout le matériel est fourni au format PDF.']
}, {
  question: 'Le produit contient-il des vidéos ?',
  answer: ['Non.', 'Professeur de Danse Classique Pro est un système pédagogique en PDF.', 'Le contenu principal utilise des illustrations, séquences, diagrammes, progressions et comparaisons visuelles pour accompagner l’enseignement.']
}, {
  question: 'Puis-je modifier les fichiers ?',
  answer: ['Non.', 'Les fichiers sont fournis en PDF et ne sont pas éditables.']
}, {
  question: 'À qui s’adresse ce système ?',
  answer: ['Aux professeurs de danse classique qui souhaitent :'],
  bullets: ['réduire leur temps de préparation ;', 'structurer davantage leurs cours ;', 'disposer de nouvelles progressions ;', 'améliorer leurs corrections ;', 'organiser le suivi de leurs élèves ;', 'disposer de cours prêts lorsque le temps manque.']
}, {
  question: 'Le système couvre-t-il plusieurs niveaux ?',
  answer: ['Oui.', 'Le contenu comprend des fondamentaux ainsi que des progressions destinées aux élèves en développement et de niveau intermédiaire.']
}, {
  question: 'Puis-je utiliser le matériel avec mes élèves ?',
  answer: ['Oui.', 'Le système est précisément conçu comme une ressource pédagogique destinée au professeur pour son travail avec ses élèves.']
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-y border-brand-line bg-brand-blush px-4 py-20 sm:py-28" data-id="element-65" data-mp="2po81brqg7p0n">
      <div className="mx-auto max-w-3xl" data-id="element-66" data-mp="2kv551buae1gr">
        <div className="text-center" data-id="element-67" data-mp="2fwtsuugirevd">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-68" data-mp="2fxvh60mjpxv1">
            Tout ce que vous devez savoir
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-brand-ink sm:text-4xl" data-id="element-69" data-mp="2avwb2izf8mue">
            Questions fréquentes
          </h2>
        </div>
        <div className="mt-12 space-y-3" data-id="element-70" data-mp="33m4yap8tdxfu">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-lg border border-brand-line bg-white" data-id="element-71" data-mp="2ypeeprxswjpo" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors duration-150 hover:bg-brand-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-coral" data-id="element-72" data-mp="1n8xy3vaifx18">
                  <span className="text-base font-semibold text-brand-ink" data-id="element-73" data-mp="7n42auoe4hbk">
                    {faq.question}
                  </span>
                  <ChevronDownIcon size={20} aria-hidden="true" className={`shrink-0 text-brand-gold transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-74" data-mp="hfa2grosq51u" />
                </button>
                <AnimatePresence initial={false} data-id="element-75" data-mp="qdvk8kmg1g1k">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-76" data-mp="ve00qancqars">
                      <div className="space-y-2 border-t border-brand-line px-6 py-5 text-sm leading-6 text-brand-muted" data-id="element-77" data-mp="21y2gs5oi6n3j">
                        {faq.answer.map(paragraph => <p key={paragraph} data-id="element-78" data-mp="2bte0l2erqki5">{paragraph}</p>)}
                        {faq.bullets && <ul className="list-disc space-y-1 pl-5 marker:text-brand-rose" data-id="element-79" data-mp="1j5huj73b7g8p">
                            {faq.bullets.map(bullet => <li key={bullet} data-id="element-80" data-mp="1e7q0o7j3tk1v">{bullet}</li>)}
                          </ul>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}